import { useEffect, useState } from "react";

export default function useAudioUrl(blob) {
  const [url, setUrl] = useState("");
  useEffect(() => {
    if (!(blob instanceof Blob)) { setUrl(""); return undefined; }
    const next = URL.createObjectURL(blob);
    setUrl(next);
    return () => URL.revokeObjectURL(next);
  }, [blob]);
  return url;
}
